import { render } from "./wfm-text.vue?vue&type=template&id=e548ad5a&scoped=true"
import script from "./wfm-text.vue?vue&type=script&lang=js"
export * from "./wfm-text.vue?vue&type=script&lang=js"

import "./wfm-text.vue?vue&type=style&index=0&id=e548ad5a&lang=css"
import "./wfm-text.vue?vue&type=style&index=1&id=e548ad5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e548ad5a"]])

export default __exports__